import { setTerm } from './helpers';

export const setIdUser = setTerm('id_user');
